var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kefu_v"},[_c('iframe',{attrs:{"src":_vm.customerServiceUrl,"title":"在线客服"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }